import classnames from "classnames";
import { useNavigate } from "react-router-dom";

import { Badge, Heading, Span, TabGroup } from "@icg360/design-system";

import { productTypeLabelMap } from "consts";
import { usePolicyDetail } from "data/ss-data-hooks";
import { capitalizeEachWord, getPageMetadata } from "utils";

import styles from "./policy-header.module.scss";

type PolicyHeaderProps = {
  tabs?: Record<string, string>[];
};

export const PolicyHeader = ({ tabs }: PolicyHeaderProps) => {
  const navigate = useNavigate();
  const currentPath = location.pathname;
  const pageMetadata = getPageMetadata(currentPath);
  const [pageTtitle] = pageMetadata.title.split(" ");
  const { data: policy, isLoading } = usePolicyDetail();

  const activeTab = tabs?.findIndex((tab) => tab.link === currentPath);
  const showTabs = activeTab !== -1;

  const policyStatusMap: { [key: string]: string } = {
    ACTIVEPOLICY: "Active",
    CANCELLEDPOLICY: "Cancelled",
    NONRENEWEDPOLICY: "Non-renewed",
  };

  return (
    <div className={styles.pageHeaderContainer}>
      <div className={styles.pagePrimaryHeader}>
        <div className={styles.pageHeadingWrapper}>
          <Heading size="lg" tag="h1">
            {pageTtitle}
          </Heading>
        </div>
        <div
          className={classnames(
            styles.policyStatusWrapper,
            isLoading && styles.notLoaded
          )}
          // Note: Remove this when new policy switcher is implemented
          style={{ display: "none" }}
        >
          <Span style={{ marginRight: "8px" }} size="sm" bold>
            {capitalizeEachWord(
              policy?.userDetails?.propertyAddress?.street1 ?? ""
            )}{" "}
            {capitalizeEachWord(
              policy?.userDetails?.propertyAddress?.street2 ?? ""
            )}{" "}
            -{" "}
            {
              productTypeLabelMap[
                policy?.userPolicyProperties?.policyType ?? ""
              ]
            }
          </Span>{" "}
          <Badge
            appearance={
              policyStatusMap[policy?.userDetails?.policyStatus ?? ""] ===
              "Active"
                ? "success"
                : "neutral"
            }
          >
            {policyStatusMap[policy?.userDetails?.policyStatus ?? ""]}
          </Badge>
        </div>
      </div>
      {showTabs && (
        <div className={styles.headerTabs}>
          <TabGroup
            activeTabIndex={activeTab}
            border={false}
            tabs={tabs?.map((tab) => ({
              className: styles.tabItem,
              name: tab.name,
              onClick: () => {
                navigate(tab.link);
              },
            }))}
          />
        </div>
      )}
    </div>
  );
};
